<template>
  <div>
    <list
      ref="refBankList"
      sort-by="bancoId"
      refetch-records-name="bancos"
      key-field="BancoId"
      :actions="actions"
      :filters.sync="filters"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :refetch-records="fetchBanks"
      :sort-dir-desc="false"
    />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import generalDataService from '@/services/generalData.service'
import List from '@/components/List.vue'

export default {
  components: {
    List,
  },
  setup() {
    const refBankList = ref(null)
    const { fetchBanks } = generalDataService()
    const filters = ref([])
    const tableColumns = [
      {
        key: 'nombre',
        label: i18n.t('AppTI.accountBank.bankName'),
        sortable: false,
      },
      {
        key: 'nombreCorto',
        label: i18n.t('AppTI.accountBank.shortName'),
        sortable: false,
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'read',
        aclResource: 'Banco',
        routeName: 'apps-bank-edit',
        params: ['bancoId'],
        icon: 'Edit2Icon',
      },
    ])
    const actions = ref([
      {
        label: i18n.t('AppTI.actions.newBank'),
        aclAction: 'create',
        aclResource: 'Banco',
        routeName: 'apps-bank-add',
        icon: 'PlusCircleIcon',
      },
    ])

    return {
      refBankList,
      fetchBanks,
      filters,
      tableColumns,
      tableActions,
      actions,
    }
  },
}
</script>
